import React from 'react';
import { Link } from 'react-router-dom';
import './stem.css';
import { FaArrowLeft, FaMedkit, FaHeartbeat, FaUserMd, FaGlobe, FaBriefcaseMedical } from 'react-icons/fa';

const MedicalPage = () => {
  const programCategories = [
    {
      title: "Medical Entrance Preparation",
      description: "Expert coaching for medical entrance exams in India and abroad",
      courses: [
        { name: "NEET UG Coaching", description: "Comprehensive preparation for National Eligibility cum Entrance Test for MBBS/BDS", icon: <FaUserMd /> },
        { name: "NEET PG Preparation", description: "Specialized coaching for postgraduate medical entrance examination", icon: <FaUserMd /> },
        { name: "AIIMS & JIPMER Preparation", description: "Focused coaching for premier medical institutes' entrance tests", icon: <FaMedkit /> },
        { name: "FMGE/MCI Screening Test", description: "Coaching for Foreign Medical Graduates Examination", icon: <FaGlobe /> }
      ]
    },
    {
      title: "International Medical Admissions",
      description: "Guidance for medical education abroad",
      courses: [
        { name: "USMLE Preparation", description: "Step-by-step coaching for all stages of the US Medical Licensing Examination", icon: <FaGlobe /> },
        { name: "PLAB (UK) Coaching", description: "Preparation for Professional and Linguistic Assessments Board test for UK", icon: <FaGlobe /> },
        { name: "Medical Study in Europe", description: "Admission guidance and language preparation for European medical schools", icon: <FaGlobe /> },
        { name: "MCCQE (Canada) Preparation", description: "Coaching for Medical Council of Canada Qualifying Examination", icon: <FaGlobe /> }
      ]
    },
    {
      title: "Allied Health Sciences",
      description: "Training for various healthcare specializations",
      courses: [
        { name: "Pharmacy Entrance Exams", description: "GPAT and other pharmacy entrance examination preparation", icon: <FaBriefcaseMedical /> },
        { name: "Nursing Career Advancement", description: "Specialized courses for nursing professionals and entrance exams", icon: <FaHeartbeat /> },
        { name: "Paramedical Sciences", description: "Training for various paramedical disciplines and career paths", icon: <FaBriefcaseMedical /> },
        { name: "Healthcare Management", description: "Administration, policy, and management in healthcare settings", icon: <FaBriefcaseMedical /> }
      ]
    }
  ];

  return (
    <div className="program-page medical-theme my-5 py-5">
      <div className="program-header">
        <Link to="/" className="text-start">
          <FaArrowLeft /> Back to Programs
        </Link>
        <div className="program-title">
          <FaMedkit className="program-header-icon" />
          <h1>Medical Programs</h1>
        </div>
        <p className="program-subtitle">Healthcare fundamentals, medical sciences, and entrance exam preparation</p>
      </div>

      <div className="program-overview">
        <h2>Why Choose Our Medical Coaching?</h2>
        <div className="features-grid">
          <div className="feature-card">
            <h3>Doctor-Led Faculty</h3>
            <p>Learn from practicing physicians and medical specialists</p>
          </div>
          <div className="feature-card">
            <h3>Concept-Based Learning</h3>
            <p>Focus on fundamentals with clinical correlations</p>
          </div>
          <div className="feature-card">
            <h3>Extensive Question Bank</h3>
            <p>Practice with thousands of MCQs and previous year papers</p>
          </div>
          <div className="feature-card">
            <h3>Regular Assessments</h3>
            <p>Weekly tests and performance analysis for improvement</p>
          </div>
        </div>
      </div>

      <div className="courses-section">
        {programCategories.map((category, categoryIndex) => (
          <div key={categoryIndex} className="course-category">
            <h2>{category.title}</h2>
            <p className="category-description">{category.description}</p>
            <div className="courses-grid">
              {category.courses.map((course, courseIndex) => (
                <div className="course-card" key={courseIndex}>
                  <div className="course-icon">{course.icon}</div>
                  <h3>{course.name}</h3>
                  <p>{course.description}</p>
                  <button className="enroll-btn">Learn More</button>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      
     
    </div>
  );
};

export default MedicalPage;